import { SYNC_LIMIT_HIGH } from '@/utilities/constants';

import { PanelDocument } from '../Panels/queryBuilder';
import { PassDocument } from '../Passes/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { RoomDocument } from '../Rooms/queryBuilder';
import { SequenceDocument } from '../Sequences/queryBuilder';
import { SurveyPointDocument } from '../SurveyPoints/queryBuilder';
import {
  LocationDocument,
  locationPushQueryBuilder,
  locationsPullQueryBuilder,
} from './queryBuilder';

export function locationsFamilyMember(
  configBuilder: ConfigBuilder,
  panels: FamilyMember<PanelDocument>,
  passes: FamilyMember<PassDocument>,
  rooms: FamilyMember<RoomDocument>,
  sequences: FamilyMember<SequenceDocument>,
  surveyPoints: FamilyMember<SurveyPointDocument>,
): FamilyMember<LocationDocument> {
  const syncConfig = configBuilder<LocationDocument>(RxdbCollectionNameV2.LOCATIONS);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, locationsPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_HIGH;
  push(syncConfig, locationPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the `syncInterval` at LiveInterval.SECONDS_60
  return create(RxdbCollectionNameV2.LOCATIONS, replicationState, [
    panels,
    passes,
    rooms,
    sequences,
    surveyPoints,
  ]);
}
